import { IconButton, Tab, Tabs } from "@material-ui/core";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@material-ui/icons";
import React from "react";
import * as Styles from "./styles";
import useTabList from "./useTabList";
import useTabSelect from "./useTabSelect";

function TopIconMenu({ hasSurvey }) {
  const [tab, setTab] = useTabSelect();
  const tabList = useTabList(
    "large",
    hasSurvey && window.location.pathname.startsWith("/rl")
  );
  const tabClasses = Styles.tab();
  const tabsClasses = Styles.tabs();
  const styleClasses = Styles.styles();
  const containerRef = React.useRef(null);

  const visibleTabs = tabList.filter((t) => t.visible);
  const currentIdx = visibleTabs.findIndex((t) => t.value === tab);
  const [needsScroll, setNeedsScroll] = React.useState(false);
  const canGoPrev = needsScroll && currentIdx > 0;
  const canGoNext =
    needsScroll && currentIdx >= 0 && currentIdx < visibleTabs.length - 1;

  const goPrev = () => {
    if (canGoPrev) setTab(visibleTabs[currentIdx - 1].value);
  };
  const goNext = () => {
    if (canGoNext) setTab(visibleTabs[currentIdx + 1].value);
  };

  React.useEffect(() => {
    const root = containerRef.current;
    if (!root) return;
    const scroller = root.querySelector(".MuiTabs-scroller");
    if (!scroller) return;
    const measure = () => {
      setNeedsScroll(scroller.scrollWidth > scroller.clientWidth + 1);
    };
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(scroller);
    ro.observe(root);
    return () => ro.disconnect();
  }, []);

  React.useEffect(() => {
    const root = containerRef.current;
    if (!root) return;
    const active = root.querySelector('[role="tab"][aria-selected="true"]');
    if (active && active.scrollIntoView) {
      active.scrollIntoView({
        block: "nearest",
        inline: "center",
        behavior: "smooth",
      });
    }
  }, [tab]);

  return (
    <div className={styleClasses.tabsContainer} ref={containerRef}>
      <IconButton
        size="small"
        className={styleClasses.tabNavButton}
        onClick={goPrev}
        disabled={!canGoPrev}
        aria-label="previous tab"
      >
        <KeyboardArrowLeft />
      </IconButton>
      <Tabs
        classes={tabsClasses}
        value={tab}
        variant="scrollable"
        scrollButtons="off"
        TabIndicatorProps={{ children: <span /> }}
      >
        {tabList.map((item) => (
          <Tab
            key={`topIconMenu-${item.value}`}
            classes={tabClasses}
            label={
              <div>
                {item.icon}
                <span>{item.title}</span>
              </div>
            }
            value={item.value}
            title={item.title}
            onClick={() => {
              setTab(item.value);
            }}
            style={{ visibility: item.visible ? "visible" : "hidden" }}
          />
        ))}
      </Tabs>
      <IconButton
        size="small"
        className={styleClasses.tabNavButton}
        onClick={goNext}
        disabled={!canGoNext}
        aria-label="next tab"
      >
        <KeyboardArrowRight />
      </IconButton>
    </div>
  );
}

export default TopIconMenu;
